module.exports = __webpack_public_path__ + "img/it_flag.e015e331.svg";